import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import useSnackBar from "../../../../components/Commons/SnackBar/useSnackBar";
import { useCompanyStore } from "../../../../store/AuthStore";
import { useEffect, useState } from "react";
import { GridColDef, GridRowsProp } from "@mui/x-data-grid";
import { SalesInvoice, SalesInvoiceDetail } from "../../../../interfaces/Sales/Invoices/salesinvoices";
import { Box } from "@mui/material";
import { Header } from "../../../../components/Header";
import { usePreferenceTypesStore } from "../../../../store/Preferences/PreferencesStore";
import { useGridPreferences } from "../../../../hooks/useGridPreferences";
import { PreferenceType } from "../../../../interfaces/Commons/Preferences/preferences";
import { FilterTable } from "../../../../components/Filter";
import { Spinner } from "../../../../components/Commons/Spinner/Spinner";
import DataTableSticky from "../../../../components/Tables/GridTableMaterialUI/DataTableSticky";
import { useSalesInvoiceDetailsColumns } from "./columns";


export const TableAnalysisSalesInvoiceDetailed = () => {
    const [t] = useTranslation("global");
    const navigate = useNavigate();
    const location = useLocation();
    const { preferenceTypes } = usePreferenceTypesStore.getState();
    const [isLoadedMyLocalPreferences, setIsLoadedMyLocalPreferences] = useState(false);
    const { showSnackBar, SnackbarComponent } = useSnackBar();
    const { companyState } = useCompanyStore();
    const [isLoadingDataTable, setIsLoadingDataTable] = useState(false);
    const [unauthorized, setUnauthorized] = useState(true);
    const [salesInvoiceData, setSalesInvoiceData] = useState<GridRowsProp>([]);
    const [messageSnack, setMessageSnack] = useState("");
    const [myPreferences, setMyPreferences] = useState({});
    const { columnsSalesInvoiceDetails } = useSalesInvoiceDetailsColumns();
    const {
        LoadColumnsOrder,
        LoadColumnsVisible,
        LoadColumnsSort,
        VerifyPreferenceOrderByResourceRoute,
        VerifyPreferenceVisualByResourceRoute,
        VerifyPreferenceSortByResourceRoute } = useGridPreferences();
    const [mySortPreference, setMySortPreference] = useState([]);
    const [columns, setColumns] = useState<GridColDef<SalesInvoiceDetail>[]>(columnsSalesInvoiceDetails)
    const initFilter = '/reportsalesinvoicedetails?filter='

    const loadTablePreferences = async () => {
        // get preferencetypes in Store
        let hasPreferenceOrder: boolean = false;
        // if exists preferencetypes
        if (preferenceTypes.length) {
            // if exists order preferences
            let myPreferencesColumnsOrder = preferenceTypes.find((item: PreferenceType) => item.preference_type_name === "GridColumnsOrder");
            if (myPreferencesColumnsOrder) {
                try {
                    const preference = await VerifyPreferenceOrderByResourceRoute(
                        "/reportsalesinvoicedetails",
                        myPreferencesColumnsOrder.preference_type_id ?? 0
                    );
                    if (preference) {
                        let myColumns = await LoadColumnsOrder("/reportsalesinvoicedetails", [], preference?.preference_value)
                        let noFormatNumberColumns = ["quantity", "discount"];
                        myColumns = myColumns.map((column: any) => {
                            if (noFormatNumberColumns.includes(column.field)) {
                                return {
                                    ...column,
                                    valueFormatter: (params: any) => {
                                        return params.value;
                                    },
                                    valueGetter: (params: any) => {
                                        return params.value;
                                    }
                                };
                            }
                            return column;
                        });
                        setColumns(myColumns);
                        hasPreferenceOrder = true;
                    }
                } catch (error) {
                    showSnackBar(`Error fetching column order preferences:${error}`, "error");
                }
            }

            let myPreferencesColumnsVisual = preferenceTypes.find((item: PreferenceType) => item.preference_type_name === "GridColumnsVisibility");
            // if exists visual preferences
            if (myPreferencesColumnsVisual) {
                try {
                    const preference = await VerifyPreferenceVisualByResourceRoute(
                        "/reportsalesinvoicedetails",
                        myPreferencesColumnsVisual.preference_type_id ?? 0
                    );
                    if (preference) {
                        let myLocalPreferences = await LoadColumnsVisible("/reportsalesinvoicedetails", preference);
                        setMyPreferences(myLocalPreferences);
                    }
                } catch (error) {
                    console.error("Error fetching column visual preferences:", error);
                }
            }

            let myPreferencesColumnsSort = preferenceTypes.find((item: PreferenceType) => item.preference_type_name === "GridColumnsSorting");
            // if exists sort preferences
            if (myPreferencesColumnsSort) {
                try {
                    const preference = await VerifyPreferenceSortByResourceRoute(
                        "/reportsalesinvoicedetails",
                        myPreferencesColumnsSort.preference_type_id ?? 0
                    );
                    if (preference) {
                        let myLocalPreferences = await LoadColumnsSort("/reportsalesinvoicedetails", preference);
                        setMySortPreference(myLocalPreferences);
                    }
                } catch (error) {
                    console.error("Error fetching column sort preferences:", error);
                }
            }

        }
        if (!hasPreferenceOrder) {
            setColumns(columnsSalesInvoiceDetails);
        }
        setIsLoadedMyLocalPreferences(true);
    }

    useEffect(() => {
        const loadInfo = async () => {
            document.title = `${companyState?.comercial_name} - ${t("reportsalesinvoicedetails.title")}`;

            if (location.state !== null) {
                if (location.state.row && location.state.row.sales_invoice_id) {
                    navigate("/salesinvoices/view", { state: { row: location.state.row } });
                }
            }
            await loadTablePreferences()
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }
        loadInfo()
    }, []);

    return (
        <>
            <Header
                size="no_title"
                child={
                    <>
                        <div className='d-flex justify-content-between'>
                            <h3>{t("reportsalesinvoicedetails.title")}</h3>
                            <FilterTable
                                setIsLoadingDataTable={setIsLoadingDataTable}
                                setDataTable={setSalesInvoiceData}
                                showSnackBar={showSnackBar}
                                columnsTable={columnsSalesInvoiceDetails}
                                initFilter={initFilter}
                                resourceRoute="/reportsalesinvoicedetails"
                            />
                        </div>
                    </>
                }
            />
            {!unauthorized && <div className='screen-container d-flex flex-column justify-content-center align-items-center'> <img alt='ERROR' style={{ height: "20rem", width: "20rem" }} src={require("../../../../assets/img/error.webp")} /> <h2>{messageSnack}</h2> </div>}
            {(isLoadedMyLocalPreferences) ?
                <div className="d-flex justify-content-center">
                    <Box sx={{ height: 'calc(100vh - 180px)', width: '100%' }}>
                        <DataTableSticky
                            columns={columns}
                            setColumns={setColumns}
                            data={salesInvoiceData}
                            entityId={"sales_invoice_detail_id"}
                            entity={`ReportSalesInvoiceDetails`}
                            preferences={myPreferences}
                            namePreferences={"/reportsalesinvoicedetails"}
                            nameOrderColumns={"/reportsalesinvoicedetails"}
                            initFilter={[]}
                            isLoading={isLoadingDataTable}
                            isChildren={true}
                            sortPreference={mySortPreference}
                            selectRows={true}
                            countColumns={["subtotal_amount", "total_amount", "quantity",]}
                        />
                    </Box>
                </div>
                :
                <Spinner isBox={false} />
            }
            <SnackbarComponent />
        </>
    )
}
